import { render, staticRenderFns } from "./Standalone.vue?vue&type=template&id=caf6e6dc&scoped=true&"
import script from "./Standalone.vue?vue&type=script&lang=js&"
export * from "./Standalone.vue?vue&type=script&lang=js&"
import style0 from "./Standalone.vue?vue&type=style&index=0&id=caf6e6dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf6e6dc",
  null
  
)

export default component.exports